import React from 'react';
import cx from 'classnames';
import { TagV2, TagV2Size } from '@zola/zola-ui/src/components/Tag/TagV2';
import FoilTexture from 'assets/images/invitations/foilTagTransparent@2x.png';

import styles from './styles.module.less';

export enum FOIL_COLORS {
  gold = 'gold',
  copper = 'copper',
  silver = 'silver',
}

interface FoilTagProps {
  className?: string;
  size?: TagV2Size;
  color?: FOIL_COLORS;
}

export const FoilTag = (props: FoilTagProps): JSX.Element => {
  const { className, size = TagV2Size.REGULAR, color = FOIL_COLORS.gold } = props;
  return (
    <TagV2 size={size} className={cx(styles.foilTag, styles[color], className)}>
      <img className={styles.foilBackground} src={FoilTexture} alt="" aria-hidden="true" />
      <span className={styles.foilText}>Stamped Foil</span>
    </TagV2>
  );
};
